import React from "react";

import logo from '../logo.svg';

const Navigation = () => {

 

  return (
    
    <nav className="main-nav is-align-items-center has-text-centered">
      <div className="container">
        <img src={logo} className="fp-logo" alt="Forward Press logo" />

        <h1>Pitch-perfect publishing</h1>
      </div>
    </nav>
  );
}



export default Navigation;








      
